import { Outlet } from 'react-router-dom'
import { ShieldAlert } from 'lucide-react'
import { useMeState } from '../lib/me.js'
import { canAccessStaff } from '../lib/role.js'

// Client-side gate for the พนักงาน / Employee-HR area (defense-in-depth on top of
// the middleware page gate). Renders the nested tabs only for Manager / HR /
// Admin; everyone else gets a clean notice. NOTE this is a SEPARATE gate from
// RequireManager — HR is in, Stock Manager is out (see lib/role.js#canAccessStaff).
export default function RequireStaff() {
  const { me, status } = useMeState()
  if (status === 'loading' && !me) {
    return <div className="px-10 py-8 text-[14px] text-slate-400">กำลังโหลด…</div>
  }
  if (!canAccessStaff(me)) {
    return (
      <div className="px-10 py-16 max-w-[560px] mx-auto text-center">
        <div className="w-12 h-12 rounded-xl bg-amber-50 text-amber-500 flex items-center justify-center mx-auto mb-4">
          <ShieldAlert size={22} strokeWidth={1.75} />
        </div>
        <h1 className="text-[18px] font-semibold text-slate-900 mb-1.5">เฉพาะฝ่ายบุคคล / ผู้จัดการ</h1>
        <p className="text-[14px] text-slate-500 leading-relaxed">
          หน้านี้เข้าถึงได้เฉพาะบัญชีที่มีสิทธิ์ Manager, HR หรือ Admin เท่านั้น
        </p>
      </div>
    )
  }
  return <Outlet />
}
